import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface ModalState {
  activeModal: string | null
  modalData: Record<string, unknown>

  // Actions
  openModal: (name: string, data?: Record<string, unknown>) => void
  closeModal: () => void
  isOpen: (name: string) => boolean
}

export const useModalStore = create<ModalState>()(
  devtools(
    (set, get) => ({
      activeModal: null,
      modalData: {},

      openModal: (name, data = {}) =>
        set({ activeModal: name, modalData: data }),

      closeModal: () =>
        set({ activeModal: null, modalData: {} }),

      isOpen: (name) => get().activeModal === name,
    }),
    { name: 'ModalStore' }
  )
)
